var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.awards),function(award){return _c('v-icon',{key:award.code,attrs:{"small":""}},[_vm._v(_vm._s(award.mdi_icon))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }